import { getCurrentInstance } from 'vue';

export default function useRouter() {
  const vue = getCurrentInstance();
  return vue.proxy.$router;
}
